import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IdMenuBalancing } from "../../../constants/IdMenuBalancing";
import { selectModalTabId } from "../../../selectors/selectModalTabId";
import { componentWithProps } from "../../generic/componentWithProps";
import { ResourceBar } from "../../generic/resource-bar/ResourceBar";
import { menuTabs } from "../../menus/menuTabs";
import { MenuWrapper } from "../../menus/MenuWrapper";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
export var _MenuBuildings = function (_a) {
    var onClose = _a.onClose, tabId = _a.tabId;
    var categoryConfig = tabId ? menuTabs[IdMenuBalancing.Build].categories[tabId] : undefined;
    var resourcesToDisplay = categoryConfig ? categoryConfig.footerResources || [] : [];
    var footerComponent = componentWithProps({
        ComponentType: ResourceBar,
        resources: resourcesToDisplay,
    });
    return (React.createElement(MenuWrapper, { type: IdMenuBalancing.Build, onClose: onClose, footerRenderer: footerComponent, modalId: IdModal.BuildingList }));
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onClose: function () { return actionModalClose(IdModal.BuildingList); },
    }, dispatch);
};
var mapState = function (state) { return ({
    tabId: selectModalTabId(state, IdModal.BuildingList),
}); };
export var MenuBuildings = connect(mapState, mapDispatch)(_MenuBuildings);



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/MenuBuildings.tsx
// module id = 2857
// module chunks = 3